import { authAxios, publicAxios } from "../config";
import { ApiKey } from "../endpoints";

export const fetchOrderDetailsReq = async (orderId) => {
  try {
    debugger;
    const res = await publicAxios.get(`${ApiKey.OrderDetails}/${orderId}`);

    const _data = res.data;
    return { error: false, data: _data, message: "", errorMsg: "" };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const updateOrderDetailsReq = async (data) => {
  try {
    const res = await publicAxios.put(`${ApiKey.OrderDetails}`, data);

    const msg = res.data.message;
    const _data = res.data;
    return { error: false, data: _data, message: msg, errorMsg: "" };
  } catch (err) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error";
    else error = "Something went wrong please try again later";
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};


